import React from 'react';
import Empty from '..';
import { TablePreloader } from '../../Preloader';

const EmptyTable = ({ loading, isEmpty, colSpan, children }) => {
  return (
    <tbody>
      {loading ? (
        <TablePreloader colSpan={colSpan} />
      ) : isEmpty ? (
        <tr>
          <td colSpan={colSpan} className="nothing-to-show">
            <Empty />
          </td>
        </tr>
      ) : (
        children
      )}
    </tbody>
  );
};

export default EmptyTable;
